import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/design-kit',
    name: 'DesignKitPage',
    component: () => import('@/modules/designKit/views/DesignKitPage.vue'),
    meta: {
      requiresAuth: false,
    },
  })
}
